import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import PackagesPage from "@/pages/PackagesPage";
import TourDetail from "@/pages/TourDetail";
import CategoryPage from "@/pages/CategoryPage";
import AboutUs from "@/pages/AboutUs";
import ContactUs from "@/pages/ContactUs";
import VideosPage from "@/pages/VideosPage";
import SearchPage from "@/pages/SearchPage";
import InfoPage from "@/pages/InfoPage";
import { Toaster } from "@/components/ui/sonner";
import { CompareProvider } from "@/context/CompareContext";
import { CompareBar } from "@/components/india/CompareBar";

// Smooth momentum scrolling (Lenis) — global
function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-white text-[var(--navy)] min-h-screen antialiased">
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <SmoothScroll />
        <ScrollToTop />
        <CompareProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/india" element={<PackagesPage scope="india" />} />
            <Route path="/world" element={<PackagesPage scope="world" />} />
            <Route path="/category/:key" element={<CategoryPage />} />
            <Route path="/package/:slug" element={<TourDetail />} />
            <Route path="/tour/:slug" element={<TourDetail />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/:slug" element={<InfoPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CompareBar />
        </CompareProvider>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
